import Structure from 'components/3cat/Structure';
import { useEffect } from 'react';
import __isEmpty from 'lodash/isEmpty';
import styles from './tablist.module.scss';
import clsx from 'clsx';

export default function TabList(props) {
    const { ancestorProps, estil } = props;
    const { activeTabWebview, setActiveTabWebview } = ancestorProps;

    useEffect(() => {
        if (activeTabWebview === undefined) {
            setActiveTabWebview(props.structure[0].finalProps.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const stylesTabs = clsx({
        [styles[estil]]: !__isEmpty(estil),
        [styles.tabs]: true
    });
    return (
        <div className={stylesTabs}>
            <ul className={styles.tabList}>
                <Structure {...props} />
            </ul>
        </div>
    );
}
